import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import SpeechRecorder from '../../questionLayout/sa/saSpeechRecorder';
import { appendScript } from '../../../../utils/appendScript';
import { removeScript } from '../../../../utils/removeScript';
import WordCollection from './wordCollection';

import FadeIn from '../../../utils/animations/fadein';
const mapStateToProps = (state) => {
	const {
		rightSectionProps,
		questionNo,
		isFeedback,
	} = state.rootReducer.testPageDetails;

	return {
		rightSectionProps,
		questionNo,
		isFeedback,
	};
};

const WordCloud = ({
	rightSectionProps: { qdomain, questionId, wordbank },
	isFeedback,
	questionNo,
}) => {
	let [wordPlaceHolder, setWordPlaceHolder] = useState([]);

	useEffect(() => {
		if (!isFeedback) {
			appendScript('wordCloudNew');
		}
		return () => {
			removeScript('wordCloudNew');
		};
	}, [isFeedback, wordbank, questionNo]);

	useEffect(() => {
		if (!!wordbank) {
			let splittedWords = wordbank.split('|');
			let wordPlaceHolder = splittedWords.map((word, index) => {
				return <span key={`${questionNo}_${index}`} className="avail"></span>;
			});
			setWordPlaceHolder(wordPlaceHolder);
		}
	}, [setWordPlaceHolder, questionNo, wordbank]);

	return (
		<section className="quiz-area-options">
			<div className="quiz-area-answer">
				<div className="arrange-words-btn mar-top">
					<WordCollection wordbank={wordbank} questionId={questionId} />
					{!isFeedback && (
						<div className="arrange-words-inposition quote">
							{wordPlaceHolder}
							<div id="cloudResponse" />
						</div>
					)}
				</div>
				{qdomain === 'S' && (
					<FadeIn className="record-container" style={{ display: 'none' }}>
						<h5>Record the sentence you have formed :</h5>
						<SpeechRecorder />
					</FadeIn>
				)}
				<div className="clearfix step-toptions-wrapper" id="div_90681">
					<div id="resetButton" className="word-question-reset resetButton">
						Reset <i className="fa fa-repeat" aria-hidden="true"></i>
					</div>
				</div>
			</div>
		</section>
	);
};

export default connect(mapStateToProps)(WordCloud);
